import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import AuthWrapper from "../../components/AuthWrapper";
import LoginContainer from "./../Login";
import SignupContainer from "./../Signup";
import RedirectRoute from "../../components/RedirectRoute";
import Dashboard from "../Dashboard";
import TrackingLinks from "../TrackingLinks";
import ReferralPartners from "../ReferralPartners";
import PartnerTracking from "../PartnerTracking";
import DetailReferralPartner from "../DetailReferralPartner";
import PartnerApproval from "../PartnerApproval";
import PartnerDashboard from "../PartnerDashboard";
import ForgotPassword from "../ForgotPassword";
import ResetPassword from "../ResetPassword";
import RedirectPartnerInfo from "../../components/RedirectRoute/RedirectPartnerInfo";

const adminRoutes = [
  {
    path: "dashboard",
    component: <Dashboard />,
  },
  {
    path: "commission-program",
    component: <div>Commission Program</div>,
  },
  {
    path: "tracking-links",
    component: <TrackingLinks />,
  },
  {
    path: "partner-tracking",
    component: <PartnerTracking />,
  },
  {
    path: "referral-partners",
    component: <ReferralPartners />,
  },
  {
    path: "partner-approval",
    component: <PartnerApproval />,
  },
  {
    path: "partner-infomation/:code",
    component: <DetailReferralPartner />,
  },
];

const partnerRoutes = [
  {
    path: "dashboard",
    component: <PartnerDashboard />,
  },
  {
    path: "my-account",
    component: <DetailReferralPartner isPartner />,
  },
];

const App = () => {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/*" element={<RedirectRoute />} />
          <Route path="/sign-in" element={<LoginContainer />} />
          <Route path="/sign-up" element={<SignupContainer />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:codes" element={<ResetPassword />} />
          <Route
            path="/admin/referral-partner/:id/:code"
            element={<RedirectPartnerInfo />}
          />
          {adminRoutes.map((item) => (
            <Route
              key={`admin/${item.path}`}
              path={`admin/${item.path}`}
              element={<AuthWrapper>{item.component}</AuthWrapper>}
            />
          ))}
          {partnerRoutes.map((item) => (
            <Route
              key={`partner/${item.path}`}
              path={`partner/${item.path}`}
              element={<AuthWrapper isPartner>{item.component}</AuthWrapper>}
            />
          ))}
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default App;
